module.exports = __webpack_public_path__ + "assets/img/right_2.6c583b38.png";